import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import "lib-flexible/flexible";

Vue.config.productionTip = false;
import "@/assets/public/common.less";
import i18n from "./i18n";
new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
